import React from 'react';

import { useCountry } from '@lt/localization';
import styled from 'styled-components';

import type { IBrowser } from 'redux-responsive';

import LazyPriceChart from '../PriceChart/LazyPriceChart';
import Title from '../Title';
import SubtitleContainer from '../SubtitleContainer';

export interface HeaderPropsType {
  browser: IBrowser;
  fullMapView: boolean;
  isEmptySearch: boolean;
  isHotelOnly: boolean;
  firstResultsFetched: boolean;
}

/**
 * Шапка страницы поиска, где содержится заголовок, гребенка и сортировка
 */
const SearchPageHeader = ({
  browser,
  fullMapView,
  isEmptySearch,
  isHotelOnly,
  firstResultsFetched,
}: HeaderPropsType): JSX.Element => {
  const { isRussia } = useCountry();

  const notFullMapView =
    browser.greaterThan.large || (browser.lessThan.extraLarge && !fullMapView);

  const isShowSorting = Boolean(
    !isEmptySearch && firstResultsFetched && notFullMapView,
  );

  const isShowPriceChart = isRussia && !isHotelOnly;

  const isShowTitle = !isEmptySearch;

  return (
    <Container>
      {isShowTitle && <StyledTitle />}

      {isShowPriceChart && <PriceChart />}

      {isShowSorting && <SubtitleContainer />}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled(Title)`
  margin-bottom: 8px;
`;

const PriceChart = styled(LazyPriceChart)`
  margin-bottom: 16px;
`;

export default SearchPageHeader;
